import Skeleton from "@mui/material/Skeleton";
import { twMerge } from "tailwind-merge";

import { OverflowTooltip } from "@/components/overflow-tooltip";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useActiveWatchlist } from "@/features/watchlist/services/get-active-watchlist";
import { useLang } from "@/hooks/use-lang";

type HeaderTitleProps = {
  disabled: boolean;
};

export const HeaderTitle = ({ disabled }: HeaderTitleProps) => {
  const { isAuthenticated } = useAuth();
  const { t } = useLang();
  const { data: activeWatchlist, isLoading, isError } = useActiveWatchlist();

  if (isAuthenticated && (isLoading || isError))
    return <Skeleton width="100%" className="ml-2" />;

  const watchlistName =
    activeWatchlist?.watchlistName ?? t.layout.watchlist.defaultWatchlistName;

  return (
    <OverflowTooltip
      title={watchlistName}
      placement="left"
      wrapperClassName={twMerge(
        "ml-2 w-full max-w-[85px] select-none whitespace-nowrap text-sm font-normal",
        disabled && "text-stone-300"
      )}
      childrenLabel="watchlist name"
    >
      {watchlistName}
    </OverflowTooltip>
  );
};
